import React, { useEffect, useRef } from "react";
import { SUPPORT_PHONE } from "../../config/support";
import { PhoneIcon } from "./HelpCard";

/**
 * Temporary: proof of delivery is not shown directly. The POD button opens
 * this popup asking the customer to contact support for the POD instead.
 */
const PodSupportModal = ({ trackingId, onClose }) => {
  const closeRef = useRef(null);

  useEffect(() => {
    closeRef.current?.focus();
    const onKey = (e) => e.key === "Escape" && onClose();
    document.addEventListener("keydown", onKey);
    return () => document.removeEventListener("keydown", onKey);
  }, [onClose]);

  return (
    <div className="modal-backdrop" onClick={onClose}>
      <div
        className="modal-card"
        role="dialog"
        aria-modal="true"
        aria-labelledby="pod-modal-title"
        onClick={(e) => e.stopPropagation()}
      >
        <h2 id="pod-modal-title" className="modal-title">Proof of delivery</h2>
        <p className="modal-text">
          Please contact our support team to get the proof of delivery for AWB{" "}
          <strong>{trackingId}</strong>.
        </p>

        <div className="modal-actions">
          <button ref={closeRef} type="button" className="btn-outline" onClick={onClose}>
            Close
          </button>
          <a className="btn-primary modal-call" href={`tel:${SUPPORT_PHONE.replace(/[^\d+]/g, "")}`}>
            <PhoneIcon />
            Contact support
          </a>
        </div>
      </div>
    </div>
  );
};

export default PodSupportModal;
